import React, { FC, useEffect } from 'react';

import { Box, FormControl, FormHelperText } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { FormLabel } from 'components/DataEntry/Form/fields/FormLabel';

import { defaultFormStyles, useStyles } from '../index';
import { DisplayFieldSchema, DisplayFieldStyles, FieldProps } from '../types';

export const DisplayField: FC<FieldProps<DisplayFieldSchema>> = ({
  name,
  field,
}) => {
  const {
    label,
    value,
    placeholder,
    helperText,
    isRequired,
    isDisabled,
    styles = {},
  } = field;
  const { setValue } = useFormContext();
  const fieldStyles = useStyles<DisplayFieldStyles>('displayField', styles);

  useEffect(() => {
    setValue(name, value ?? placeholder, { shouldValidate: true });
  }, [name, placeholder, setValue, value]);

  return (
    <FormControl
      key={`${name}-control`}
      isRequired={isRequired}
      isDisabled={isDisabled}
      {...fieldStyles.control}
    >
      {!!label && (
        <FormLabel
          htmlFor={name}
          label={label}
          styles={fieldStyles.label}
          isRequired={isRequired}
        />
      )}
      <Box
        border="1px solid"
        borderColor="componentBorder"
        {...fieldStyles.value}
      >
        {value ?? placeholder}
      </Box>
      {!!helperText && (
        <FormHelperText {...fieldStyles.helperText}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
